import { CSSVariablesResolver } from '@mantine/core';

const resolver: CSSVariablesResolver = (theme) => ({
  variables: {
    '--mobile-bottom-button-height': '80px',
    '--rewards-light-gradient': theme.other.tokens.gradients['rewards-light'],
    '--rewards-bold-gradient': theme.other.tokens.gradients['rewards-bold'],
  },
  light: {},
  dark: {},
});

export { resolver };
